// import { Box, Card, Checkbox, Table, TableCell, TableRow, Typography } from "@mui/material";
// import { useEffect, useState } from "react";
import MessagesPage from "./MessagesPage";


const module = {
    routeProps: {
        path: 'MOTD',
        component : MessagesPage
    },

    name: "Messages",
    label: "Messages",
    title: "Messages",
    showOnMenu: true
}

export default module;